import { REQUEST_TYPES } from '.';
import { bodyHasError } from '../lib/validation/serverErrors';

// Proxied to http://localhost:8080/mgmw/rest/api in setupProxy.js
const DL_SCAN_API_URL =  '/DLID_SCAN_DEV_API';

export const DL_SCAN_STATUS = {
  IN_PROGRESS: 'InProgress',
  CANCELLED: 'Cancelled',
  COMPLETED: 'Completed',
};

export const DL_SCAN_ERROR_CODES = {
  SCAN_SESSION_NF: 'MGMW_E_6404',
  SCAN_SESSION_CANCELLED: 'MGMW_E_6405',
  SCAN_SESSION_CREATE_FAILED: 'MGMW_E_6406',
  SCAN_SESSION_UPDATE_FAILED: 'MGMW_E_6407',
  SCAN_SESSION_STATUS_RETRIEVAL_FAILED: 'MGMW_E_6408',
};

export const hasScanSessionError = body =>
  bodyHasError(body, { errorCodes: Object.values(DL_SCAN_ERROR_CODES) });

export const createScanSessionRequest = () => ({
  type: '[API] Create DL Scan Session',
  //location: DL_SCAN_API_URL,
  url: '/scanservice/v1/createScanSession',
  APIMethod: REQUEST_TYPES.POST,
  nonBlocking: true,
});

export const pollScanResultsRequest = sessionId => ({
  type: '[API] Poll DL Scan Results',
  //location: DL_SCAN_API_URL,
  url: `/scanservice/v1/getScanStatus/?session_id=${encodeURIComponent(sessionId)}`,
  APIMethod: REQUEST_TYPES.GET,
  nonBlocking: true,
});

export const markScanInProgressRequest = sessionId => ({
  type: '[API] Mark DL Scan In Progress',
  //location: DL_SCAN_API_URL,
  url: '/scanservice/v1/updateScanStatus',
  APIMethod: REQUEST_TYPES.POST,
  nonBlocking: true,
  body: {
    session_id: sessionId,
    scanStatus: DL_SCAN_STATUS.IN_PROGRESS
  },
});

export const cancelScanSessionRequest = sessionId => ({
  type: '[API] Cancel DL Scan Session',
  //location: DL_SCAN_API_URL,
  url: '/scanservice/v1/updateScanStatus',
  APIMethod: REQUEST_TYPES.POST,
  nonBlocking: true,
  body: {
    session_id: sessionId,
    scanStatus: DL_SCAN_STATUS.CANCELLED
  },
});

export const updateScanValueRequest = (sessionId, scanValue) => ({
  type: '[API] Update DL Scan Value',
  //location: DL_SCAN_API_URL,
  url: '/scanservice/v1/updateScanStatus',
  APIMethod: REQUEST_TYPES.POST,
  nonBlocking: true,
  body: {
    session_id: sessionId,
    scanStatus: DL_SCAN_STATUS.COMPLETED,
    scannedDetails: scanValue,
  },
});
